import React from 'react';
export const useToggle: (
    initialValue: boolean
) => [state: boolean, toggleState: () => void] = initialValue => {
    const [state, setState] = React.useState<boolean>(initialValue);

    const toggleState = React.useCallback(
        () => setState(prevState => !prevState),
        []
    );

    return [state, toggleState];
};
